
  import { Outlet } from "react-router-dom";

  function DropPage() {
    return (
      <div className="">
        <Outlet />
      </div>
    )
  }
  
  export default DropPage;
  